import PubSub from "underpub-js";

var PopupPlace = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-PopupPlace',
	};

	$.extend(true, this.options, options);

};

PopupPlace.prototype.init = function() {

	var self = this;

};

export default PopupPlace;
